import React from 'react';
import { Sizes, Options } from 'common/hooks/use-optimized-images';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';

interface ReviewGalleryPictureProps {
  src: string;
  alt: string;
  loading?: 'lazy' | 'eager';
  width?: number;
  height?: number;
  className?: string;
  sizes?: Sizes;
  options?: Options;
  onClick?: () => void;
}

export const ReviewGalleryPicture: React.FC<ReviewGalleryPictureProps> = ({
  src,
  alt,
  loading = 'lazy',
  width = 300,
  height = 300,
  className,
  onClick,
}) => {
  return (
    <ImagePlaceholder
      className={className}
      onClick={onClick}
      src={src}
      loading={loading}
      fallbackWidth={205}
      fallbackHeight={160}
      alt={alt}
      width={width}
      height={height}
    />
  );
};
